import { createRef, RefObject, useEffect, useRef } from "react";

import { isNotNullNorUndefined } from "utils/tsHelpers";

export function useListScrollEffects({
  activeItemId,
  listItemIds,
  scrollOffset = 12,
}: {
  activeItemId: string | null;
  listItemIds: string[];
  scrollOffset?: number;
}) {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const itemsRef = useRef<RefObject<HTMLDivElement | null>[]>(
    listItemIds.map(() => createRef<HTMLDivElement>()),
  );

  useEffect(() => {
    const activeItemIndex = listItemIds.findIndex((id) => id === activeItemId);
    const activeItemIndexElementRef = itemsRef.current?.[activeItemIndex];
    // auto scroll to next active item
    if (
      isNotNullNorUndefined(activeItemIndexElementRef?.current) &&
      isNotNullNorUndefined(scrollContainerRef.current)
    ) {
      scrollContainerRef.current.scrollTo({
        top: activeItemIndexElementRef.current.offsetTop - scrollOffset,
        behavior: "smooth",
      });
    }
  }, [activeItemId, listItemIds, scrollOffset]);

  const setScrollPosition = (position: number) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: position });
    }
  };

  return {
    scrollContainerRef,
    itemsRef,
    setScrollPosition,
  };
}
